import { setNewsDetail } from '../../action';
import { identityPayload, createReducer, forAction } from '../../utils';

const initialState = null;

export default createReducer(
  [forAction(setNewsDetail, identityPayload)],
  initialState,
);
